(function () {
  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function highlightQuery(text, query) {
    if (!query) return escapeHtml(text);
    var safeText = String(text || "");
    var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var regex = new RegExp("(" + escapedQuery + ")", "ig");
    return escapeHtml(safeText).replace(regex, "<mark>$1</mark>");
  }

  function toLabel(type) {
    if (type === "products") return "Product";
    if (type === "pages") return "Page";
    if (type === "articles") return "Article";
    if (type === "collections") return "Collection";
    return "Result";
  }

  function buildEndpoint() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return "/";
  }

  function SearchAgent(root) {
    this.root = root;
    this.form = root.querySelector(".search-agent__form");
    this.input = root.querySelector(".search-agent__input");
    this.panel = root.querySelector("[data-search-agent-panel]");
    this.results = root.querySelector("[data-search-agent-results]");
    this.loading = root.querySelector("[data-search-agent-loading]");
    this.quickTermsContainer = root.querySelector("[data-search-agent-quick-terms]");
    this.viewAll = root.querySelector("[data-search-agent-view-all]");
    this.quickTerms = this.parseQuickTerms(root.getAttribute("data-search-agent-quick-terms"));
    this.types = root.getAttribute("data-search-agent-types") || "product,page,article,collection";
    this.limit = parseInt(root.getAttribute("data-search-agent-limit"), 10) || 8;
    this.activeIndex = -1;
    this.optionElements = [];
    this.query = "";
    this.debounce = null;
    this.controller = null;
  }

  SearchAgent.prototype.parseQuickTerms = function (terms) {
    if (!terms) return [];
    return terms
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean)
      .slice(0, 5);
  };

  SearchAgent.prototype.openPanel = function () {
    this.panel.hidden = false;
    this.input.setAttribute("aria-expanded", "true");
  };

  SearchAgent.prototype.closePanel = function () {
    this.panel.hidden = true;
    this.input.setAttribute("aria-expanded", "false");
    this.input.removeAttribute("aria-activedescendant");
    this.activeIndex = -1;
    this.optionElements = [];
  };

  SearchAgent.prototype.setLoading = function (visible) {
    this.loading.hidden = !visible;
  };

  SearchAgent.prototype.renderQuickTerms = function () {
    var self = this;
    if (!this.quickTerms.length || this.query.length > 0) {
      this.quickTermsContainer.innerHTML = "";
      return;
    }

    this.quickTermsContainer.innerHTML =
      '<p class="search-agent__quick-title">Popular searches</p>' +
      this.quickTerms
        .map(function (term) {
          return (
            '<button class="search-agent__chip" type="button" data-search-agent-chip="' +
            escapeHtml(term) +
            '">' +
            escapeHtml(term) +
            "</button>"
          );
        })
        .join("");

    this.quickTermsContainer.querySelectorAll("[data-search-agent-chip]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var value = chip.getAttribute("data-search-agent-chip") || "";
        self.input.value = value;
        self.query = value;
        var destination = self.form.getAttribute("action") + "?q=" + encodeURIComponent(value);
        window.location.href = destination;
      });
    });
  };

  SearchAgent.prototype.setViewAllLink = function (query) {
    if (!query) {
      this.viewAll.hidden = true;
      return;
    }
    this.viewAll.href = this.form.getAttribute("action") + "?q=" + encodeURIComponent(query);
    this.viewAll.textContent = 'View all results for "' + query + '"';
    this.viewAll.hidden = false;
  };

  SearchAgent.prototype.renderEmpty = function (query) {
    this.results.innerHTML =
      '<div class="search-agent__empty">No quick matches for <strong>' +
      escapeHtml(query) +
      "</strong></div>";
    this.optionElements = [];
    this.activeIndex = -1;
  };

  SearchAgent.prototype.renderResults = function (items) {
    var grouped = {};
    var html = "";
    var self = this;

    items.forEach(function (item) {
      if (!grouped[item.type]) grouped[item.type] = [];
      grouped[item.type].push(item);
    });

    ["products", "collections", "pages", "articles"].forEach(function (type) {
      var list = grouped[type] || [];
      if (!list.length) return;

      html += '<section class="search-agent__group" aria-label="' + escapeHtml(toLabel(type)) + '">';
      html += '<h4 class="search-agent__group-title">' + escapeHtml(toLabel(type)) + "</h4>";

      list.forEach(function (item, index) {
        var optionId = self.root.getAttribute("data-search-agent-id") + "-option-" + type + "-" + index;
        html +=
          '<a class="search-agent__option" href="' +
          escapeHtml(item.url) +
          '" id="' +
          optionId +
          '" role="option" aria-selected="false">' +
          '<span class="search-agent__option-title">' +
          highlightQuery(item.title, self.query) +
          "</span>" +
          '<span class="search-agent__option-type">' +
          escapeHtml(toLabel(item.type)) +
          "</span>" +
          "</a>";
      });

      html += "</section>";
    });

    this.results.innerHTML = html;
    this.optionElements = Array.prototype.slice.call(this.results.querySelectorAll(".search-agent__option"));
    this.activeIndex = -1;
  };

  SearchAgent.prototype.setActiveOption = function (index) {
    var self = this;
    this.optionElements.forEach(function (option, i) {
      var active = i === index;
      option.setAttribute("aria-selected", active ? "true" : "false");
      if (active) {
        self.input.setAttribute("aria-activedescendant", option.id);
        option.scrollIntoView({ block: "nearest" });
      }
    });
  };

  SearchAgent.prototype.fetchSuggestions = function (query) {
    var self = this;
    this.query = query;
    this.openPanel();
    this.renderQuickTerms();
    this.setViewAllLink(query);

    if (query.length < 2) {
      this.results.innerHTML = "";
      this.setLoading(false);
      return;
    }

    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    this.setLoading(true);

    var endpoint = buildEndpoint();
    var url =
      endpoint +
      "search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=" +
      encodeURIComponent(this.types) +
      "&resources[limit]=" +
      encodeURIComponent(String(this.limit));

    fetch(url, { signal: this.controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error("Request failed");
        return response.json();
      })
      .then(function (data) {
        var results = (data && data.resources && data.resources.results) || {};
        var merged = [];

        ["products", "collections", "pages", "articles"].forEach(function (key) {
          var list = results[key] || [];
          list.forEach(function (item) {
            if (item && item.title && item.url) {
              merged.push({ title: item.title, url: item.url, type: key });
            }
          });
        });

        self.setLoading(false);
        if (!merged.length) {
          self.renderEmpty(query);
          return;
        }

        self.renderResults(merged.slice(0, self.limit));
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return;
        self.setLoading(false);
        self.renderEmpty(query);
      });
  };

  SearchAgent.prototype.bindEvents = function () {
    var self = this;

    this.input.addEventListener("focus", function () {
      self.query = self.input.value.trim();
      self.openPanel();
      self.renderQuickTerms();
      self.setViewAllLink(self.query);
    });

    this.input.addEventListener("input", function () {
      var query = self.input.value.trim();
      clearTimeout(self.debounce);
      self.debounce = setTimeout(function () {
        self.fetchSuggestions(query);
      }, 140);
    });

    this.input.addEventListener("keydown", function (event) {
      if (self.panel.hidden || !self.optionElements.length) {
        if (event.key === "Escape") self.closePanel();
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        self.activeIndex = (self.activeIndex + 1) % self.optionElements.length;
        self.setActiveOption(self.activeIndex);
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        self.activeIndex = (self.activeIndex - 1 + self.optionElements.length) % self.optionElements.length;
        self.setActiveOption(self.activeIndex);
        return;
      }

      if (event.key === "Enter" && self.activeIndex >= 0) {
        event.preventDefault();
        window.location.href = self.optionElements[self.activeIndex].getAttribute("href");
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        self.closePanel();
      }
    });

    this.form.addEventListener("submit", function (event) {
      if (self.activeIndex >= 0 && self.optionElements[self.activeIndex]) {
        event.preventDefault();
        window.location.href = self.optionElements[self.activeIndex].getAttribute("href");
      }
    });

    document.addEventListener("click", function (event) {
      if (!self.root.contains(event.target)) self.closePanel();
    });
  };

  SearchAgent.prototype.init = function () {
    if (!this.form || !this.input || !this.panel || !this.results) return;
    this.renderQuickTerms();
    this.bindEvents();
  };

  function initSearchAgents() {
    var roots = document.querySelectorAll("[data-search-agent]");
    roots.forEach(function (root) {
      if (root.dataset.searchAgentInitialized === "true") return;
      root.dataset.searchAgentInitialized = "true";
      var agent = new SearchAgent(root);
      agent.init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSearchAgents);
  } else {
    initSearchAgents();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector("[data-search-agent]");
    if (!root) return;
    if (root.dataset.searchAgentInitialized === "true") return;
    root.dataset.searchAgentInitialized = "true";
    var agent = new SearchAgent(root);
    agent.init();
  });
})();
